<template>
  <v-card class="mb-5" color="grey lighten-1">
    <v-progress-linear color="blue" indeterminate v-if="loading"></v-progress-linear>
    <v-card-title class="grey lighten-4 py-4 title">
      Import results:
    </v-card-title>

    <v-list two-line subheader>
      <v-subheader inset>Importing steps</v-subheader>

      <v-list-tile>
        <v-list-tile-avatar>
          <v-icon class="check_circle" large :color="importStatus.start">check_circle</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>1. Creating</v-list-tile-title>
          <v-list-tile-sub-title>Creating result records for upload ...</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile>
        <v-list-tile-avatar>
          <v-icon class="check_circle" large :color="importStatus.upload">check_circle</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>2. Uploading</v-list-tile-title>
          <v-list-tile-sub-title>Uploading results to the database ...</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile>
        <v-list-tile-avatar>
          <v-icon class="check_circle" large :color="importStatus.finish">check_circle</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>3. Import complete</v-list-tile-title>
          <v-list-tile-sub-title>Import of results is now complete</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>

    </v-list>
  </v-card>
</template>


<script>
import moment from "moment";
import fb from "@/firebaseConfig";
import * as apiEvents from "@/api/events";

export default {
  props: ["value", "eventName", "eventId", "resultsurl", "triggerImport"],
  data: () => ({
    loading: false,
    importStatus: {
      start: "amber",
      finish: "",
      upload: ""
    }
  }),
  mounted() {},
  watch: {
    triggerImport(val) {
      if (val) {
        this.importResults();
      }
    }
  },
  methods: {
    async importResults() {
      //reset the status
      this.importStatus.start = "amber";
      this.importStatus.upload = "";
      this.importStatus.finish = "";
      this.loading = true;

      this.importStatus.start = "green";
      this.importStatus.upload = "amber";

      apiEvents
        .importResults(this.eventId,this.value)
        .then(e => {
          this.importStatus.upload = "green";
          this.importStatus.finish = "green";
        })
        .catch(e => {
          this.importStatus.finish = "red";
          apiEvents.handleError(e);
        })
        .finally(() => {
          this.loading = false;
          this.$emit("importComplete");
        });
    }
  },
  computed: {},

  components: {}
};
</script>